import type { PropsOf } from '@emotion/react';
import styled from '@emotion/styled';
import { tokens, Link } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

import HotjarLogo from './logo-hotjar.svg';

export interface CompanyLogoProps {
  companyLogoUrl?: string;
  siteDashboardOverviewUrl: string;
  className?: string;
  onClick?: PropsOf<'a'>['onClick'];
}

// reset specific styling from hotsauce
const StyledLink = styled(Link)`
  display: block;
  height: ${tokens.spacer.x5};
  padding: ${tokens.spacer.x1};
  text-align: center;
  width: auto;
  max-width: 120px;
  text-decoration: none;
  border-radius: ${tokens.radius.m};

  &:focus {
    box-shadow: none;
  }
  &:focus-visible {
    ${tokens.focus()};
  }
  &:hover {
    color: inherit;
    opacity: 85%;
  }
`;

const StyledImage = styled.img`
  height: 100%;
`;

export function CompanyLogo({
  companyLogoUrl,
  siteDashboardOverviewUrl,
  className,
  onClick,
}: CompanyLogoProps): JSX.Element {
  const { t } = useTranslation('navigation');
  return (
    <StyledLink
      kind="inline"
      id="logo"
      data-testid="hotjar-logo"
      className={className}
      href={siteDashboardOverviewUrl}
      onClick={onClick}
    >
      {
        (
          <StyledImage src={companyLogoUrl || HotjarLogo} alt={t('CompanyLogo.imageAlt')} />
        ) as unknown as string // temporary until we can import a basic Link with routing
      }
    </StyledLink>
  );
}
